import secureLocalStorage from "react-secure-storage";
import CircularProgress from "@material-ui/core/CircularProgress";
import React, { Component } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../Action/SuperAdmin/TenantCreation";
import "../../Styles/SuperAdminTenantCreation.scss";
import * as moment from "moment";
import { Checkbox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";

class SuperAdminTenantCretion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      servicePlanTypes: null,
      ServicePlan: "",
      logoImage: "",
      tenantUserLimits: "0",
      errors: {},
      heatmapMatrixlist: [
        { text: "3X3", value: 3 },
        { text: "4X4", value: 4 },
        { text: "5X5", value: 5 },
        { text: "6X6", value: 6 },
        { text: "7X7", value: 7 },
        { text: "8X8", value: 8 },
      ],
      heatmapMatrix_value: { text: "5X5", value: 5 },
      probabiltyArray: [
        {
          OrderId: 1,
          fullDescription: "",
          abbreviation: "",
          probabilityDescription:""

        },
        {
          OrderId: 2,
          fullDescription: "",
          abbreviation: "",
          probabilityDescription:""

        },
        {
          OrderId: 3,
          fullDescription: "",
          abbreviation: "",
          probabilityDescription:""

        },
        {
          OrderId: 4,
          fullDescription: "",
          abbreviation: "",
          probabilityDescription:""

        },
        {
          OrderId: 5,
          fullDescription: "",
          abbreviation: "",
          probabilityDescription:""

        },
        {
          OrderId: 6,
          fullDescription: "",
          abbreviation: "",
          probabilityDescription:""

        },
        {
          OrderId: 7,
          fullDescription: "",
          abbreviation: "",
          probabilityDescription:""

        },
        {
          OrderId: 8,
          fullDescription: "",
          abbreviation: "",
          probabilityDescription:""

        },
      ],
      selected:0,
    };
   
  }

  componentDidMount() {
    this.servicePlanTypes();
    if (this.props.location.tenantRowData) {
      this.populate(this.props.location.tenantRowData);
    }
  }
  componentDidUpdate(){}

  populate = (data) => {
    const { actions } = this.props;
    actions.tenantServicePlan(data.value);
    actions.tenantName(data.tenantName);
    actions.tenantKey(data.tenantKey);
    actions.tenantMobile(data.tenantMobile);
    actions.tenantEmail(data.tenantEmail);
    actions.tenantUserLimits(data.userLimit);
    actions.tenantTelephone(data.tenantPhoneNo);
    actions.tenantDesc(data.tenantDescription);
    actions.tenantServicePlan(data.tenantServicePlan);
    actions.addressLine1(data.tenantAddress);
    actions.tenantCountry(data.country);
    actions.tenantState(data.state);
    actions.tenantCity(data.city);
    actions.tenantPostalCode(data.postalCode);
    actions.primeSubscription(data.isPrimeSubsibed);
    actions.handleTasksModuleEnabled(data.isTasksModuleEnabled);
    if (data.activationDate) {
      let date = moment(new Date(data.activationDate)).format("YYYY-MM-DD");
      actions.activationDate(date);
    }
    if (data.renewalDate) {
      let date = moment(new Date(data.renewalDate)).format("YYYY-MM-DD");
      actions.tenantRenewalDate(date);
    }
    if (data.validTillDate) {
      let date = moment(new Date(data.validTillDate)).format("YYYY-MM-DD");
      actions.tenantValidDate(date);
    }
    if (data.heatmapCount) {
      let temp = this.state.heatmapMatrixlist.find(
        (item) => item.value === data.heatmapCount
      );
      let prob = this.state.probabiltyArray;
      if (
        data.probabilityRangeLabelList &&
        data.probabilityRangeLabelList.length >= 3
      ) {
        prob = this.state.probabiltyArray.map((item, index) => {
          if (data.probabilityRangeLabelList.length > index) {
            item = data.probabilityRangeLabelList[index];
          }
          return item;
        });
      }
      this.setState({
        probabiltyArray: [...prob],
        heatmapMatrix_value: temp
      });
    }
  
  };
  
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.tenantcreationfailure != null) {
      nextProps.history.push("/login");
      // secureLocalStorage.clear();
      return { null: nextProps.actions.TenantFailure(null) };
    }
    return null;
  }

  
  servicePlanTypes() {
    const options = [
      { label: "Free", value: "Free" },
      { label: "Standard", value: "Standard" },
      { label: "Premium", value: "Premium" },
    ];
    this.setState({ servicePlanTypes: options });
  }

  handleDropDownChange = (Data, name) => {
    const { actions } = this.props;
    if (name === "ServicePlan") {
      this.setState({ ServicePlan: Data });
      actions.tenantServicePlan(Data.value);
    }
  };

  handleTenantName = (e) => {
    const { actions } = this.props;
    let tenantName = e.target.value;
    actions.tenantName(tenantName);
  };

  handleTenantKey = (e) => {
    const { actions } = this.props;
    let tenantKey = e.target.value;
    actions.tenantKey(tenantKey);
  };

  handleTenantMobile = (e) => {
    const { actions } = this.props;
    let tenantMobile = e.target.value;
    actions.tenantMobile(tenantMobile);
  };

  handleTenantEmail = (e) => {
    const { actions } = this.props;
    // let tenantEmail = e.target.value;
    // actions.tenantEmail(tenantEmail);
    let email = e.target.value;
    if (this.validateEmail(email)) {
      const { actions } = this.props;
      actions.tenantEmail(email);
    } else {
      return;
    }
  };
  validateEmail = async (inputtxt) => {
    let mailvalidity = /^([a-zA-Z0-9\._]+)@([a-zA-Z0-9])+.([a-z]+)(.[a-z]+)?$/;
    let r = await mailvalidity.test(inputtxt);
    // console.log("mailvaliditity");
    if (r) {
      return true;
    } else {
      return false;
    }
  };

  handleTenantUserLimits = (e) => {
    const { actions } = this.props;
    let tenantUserLimits = e.target.value;
    actions.tenantUserLimits(tenantUserLimits);
  };

  handleTenantTelephone = (e) => {
    let telephone = e.target.value;

    if (this.validatePhone(telephone)) {
      const { actions } = this.props;
      actions.tenantTelephone(telephone);
    } else {
      return;
    }
  };

  validatePhone = async (inputtxt) => {
    let phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    let a = await phoneno.test(inputtxt);
    return a;
  };

  handleTenantDesc = (e) => {
    const { actions } = this.props;
    let tenantDescription = e.target.value;
    actions.tenantDesc(tenantDescription);
  };

  handleServicePlan = (e) => {
    const { actions } = this.props;
    let tenantServicePlan = e.target.value;
    actions.tenantServicePlan(tenantServicePlan);
  };

  handleAddressLine1 = (e) => {
    const { actions } = this.props;
    let addressLine1 = e.target.value;
    actions.addressLine1(addressLine1);
  };

  handleAddressLine2 = (e) => {
    const { actions } = this.props;
    let addressLine2 = e.target.value;
    actions.addressLine2(addressLine2);
  };

  handleTenantCountry = (e) => {
    const { actions } = this.props;
    let country = e.target.value;
    actions.tenantCountry(country);
  };
  handleTenantState = (e) => {
    const { actions } = this.props;
    let state = e.target.value;
    actions.tenantState(state);
  };
  handleTenantCity = (e) => {
    const { actions } = this.props;
    let city = e.target.value;
    actions.tenantCity(city);
  };
  handleTenantPostalCode = (e) => {
    const { actions } = this.props;
    let postalCode = e.target.value;
    actions.tenantPostalCode(postalCode);
  };

  handleTenantLogo = (e) => {
    e.preventDefault();
    const { actions } = this.props;
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      actions.TenantLogo(reader.result);
    };
  };
  handleActivationDate = (e) => {
    const { actions } = this.props;
    let tenantActivationDate = e.target.value;
    actions.activationDate(tenantActivationDate);
    this.dateValidation(e);
  };
  handleTenantRenewalDate = (e) => {
    const { actions } = this.props;
    let renewalDate = e.target.value;
    actions.tenantRenewalDate(renewalDate);
    this.dateValidation(e);
  };
  dateValidation = (e) => {
    const { actions } = this.props;
    let startdate = new Date(e.target.value);
    startdate.setFullYear(startdate.getFullYear() + 1);

    let addyears = moment(startdate).format("YYYY-MM-DD");
    actions.tenantValidDate(addyears);
  };

  handleTenantValidDate = (e) => {
    const { actions } = this.props;
    let validDate = e.target.value;
    actions.tenantValidDate(validDate);
  };
  handleprimeSubscription = (e) => {
    const { actions } = this.props;
    let subscription = e.value;
    actions.primeSubscription(subscription);
  };
  handleTasksModuleEnabled = (e) => {
    const { actions } = this.props;
    let subscription = e.value;
    actions.handleTasksModuleEnabled(subscription);
  };
  
  handletenantMatrix = (e) => {
    const { actions } = this.props;
    let matrix = e.target.value;
    this.setState({
      heatmapMatrix_value: matrix,
    });

    actions.tenantMatrix(matrix);
  };
  phonenumber = (inputtxt) => {
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (inputtxt.match(phoneno)) {
      return true;
    } else {
      return false;
    }
  };

  cancelTenantCreationData(event) {
    event.preventDefault();
    this.props.history.push("/superadmin/home/Remove");
  }
  tenantKeyValidation = async (inputtxt) => {
    var tenantKeyPattern = /^[a-zA-Z]*$/;
    var flag = await tenantKeyPattern.test(inputtxt);
    if (flag) {
      return true;
    } else {
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submitted: true });
    const {
      actions,
      TenantName,
      TenantKey,
      TenantTelephone,
      TenantUserLimit,
      TenantEmail,
      ServicePlan,
      AddressLine1,
      TenantCountry,
      TenantState,
      TenantCity,
      TenantPostalCode,
      TenantLogo,
      ActivationDate,
      TenantRenewalDate,
      TenantValidDate,
      PrimeSubscription,
      IsTasksModuleEnabled
      
    } = this.props;
for (var i = 0; i < this.state.heatmapMatrix_value?.value; i++) {
  if (
    !this.state.probabiltyArray[i]?.fullDescription ||
    this.state.probabiltyArray[i]?.fullDescription == "" ||
    this.state.probabiltyArray[i]?.fullDescription === null ||
    this.state.probabiltyArray[i]?.fullDescription == undefined
  ) {
    toastr.error("Full Description is Required");
    return;
  }
  if (
    !this.state.probabiltyArray[i]?.abbreviation ||
    this.state.probabiltyArray[i]?.abbreviation === "" ||
    this.state.probabiltyArray[i]?.abbreviation === null ||
    this.state.probabiltyArray[i]?.abbreviation === undefined
  ) {
    toastr.error("Abbreviation is Required");
    return;
  }
  if (
    !this.state.probabiltyArray[i]?.probabilityDescription ||
    this.state.probabiltyArray[i]?.probabilityDescription === "" ||
    this.state.probabiltyArray[i]?.probabilityDescription === null ||
    this.state.probabiltyArray[i]?.probabilityDescription === undefined
  ) {
    toastr.error("Range Definition is Required");
    return;
  }
  
}


    if (TenantName && TenantKey && TenantEmail) {
      var flag = await this.tenantKeyValidation(TenantKey);
      if (!flag) {
        toastr.error("Tenant key allowed only Alphabet");
        return;
      }

      var r = await this.validateEmail(TenantEmail);
      if (!r) {
        toastr.error("Invalid Email Id ");
        return;
      }

      const params = {
        LastUpdated: new Date(),
        RecoveryState: "30",
        TenantName: TenantName,
        TenantKey: TenantKey,
        TenantPhoneNo: TenantTelephone,
        tenantemail: TenantEmail,
        ServicePlan: ServicePlan ? ServicePlan : this.state.ServicePlan.value,
        TenantAddress: AddressLine1, // + ", " + AddressLine2,
        TenantCountry: TenantCountry,
        TenantState: TenantState,
        TenantCity: TenantCity,
        TenantPostalCode: TenantPostalCode,
        TenantLogo: TenantLogo ? TenantLogo : this.state.logoImage,
        UserLimit: parseInt(TenantUserLimit),
        TenantId: this.props.location.tenantRowData
          ? this.props.location.tenantRowData.tenantId
          : undefined,
        ActivationDate: ActivationDate,
        RenewalDate: TenantRenewalDate,
        ValidTillDate: TenantValidDate,
        IsPrimeSubsibed: PrimeSubscription,
        IsTasksModuleEnabled:IsTasksModuleEnabled,
        HeatmapCount: this.state.heatmapMatrix_value?.value,
        ProbabilityRangeLabelList: this.state.probabiltyArray.slice(
          0,
          this.state.heatmapMatrix_value?.value || 5
        ),
      };
      console.log("params", params);
      actions.TenantCreation(params);
    } else {
      toastr.error("Please enter values in all fields.");

    }
    setTimeout(async () => {
      let path = "/superadmin/home/Remove";
      this.props.history.push(path);
    }, 1000);
    
  };
  handleFullDescription = (e, i) => {
    try {
      let probabiltyArray = this.state.probabiltyArray.map((item, index) => {
        if (index === i) {
          item["fullDescription"] = e.target.value?.trim();
        }
        return item;
      });
      this.setState({ probabiltyArray: probabiltyArray });
    } catch (err) {
      console.log(err);
    }
  };
  handleprobabilityDescription = (e, i) => {
    try {
      let probabiltyArray = this.state.probabiltyArray.map((item, index) => {
        if (index === i) {
          item["probabilityDescription"] = e.target.value?.trim();
        }
        return item;
      });
      this.setState({ probabiltyArray: probabiltyArray });
    } catch (err) {
      console.log(err);
    }
  };
  getFullDescriptionValue = (i) => {
    let obj = this.state.probabiltyArray[i];
    // console.log("obj",obj)
    // if(obj.fullDescription===""){
    //   toastr.error("Please enter values in all fields.");

    // }

    // console.log("i",i)

    return obj?.fullDescription;
  };
  getprobabilityDescriptionValue = (i) => {
    let obj = this.state.probabiltyArray[i];
    return obj?.probabilityDescription;
  };
  handleAbbreviation = (e, i) => {
    try {
      let probabiltyArray = this.state.probabiltyArray.map((item, index) => {
        if (index === i) {
          item["abbreviation"] = e.target.value?.trim()?.toUpperCase();
        }
        return item;
      });
      this.setState({ probabiltyArray: probabiltyArray });
    } catch (err) {
      console.log(err);
    }
  };
  getAbbreviationValue = (i) => {
    let obj = this.state.probabiltyArray[i];
    return obj?.abbreviation;
  };
  getProbabilityMatrix = () => {
    let matrixfields = [];
    for (let i = 0; i < this.state.heatmapMatrix_value?.value; i++) {
     let value=false;
     let z=i+1
     if(z%2==0){
      value=true
     }
      matrixfields.push(
        <div className="probability-field" style={{marginLeft:value?'10px':'20px', float:value?"right":'left' }}>
        <label>Full Description {i+1} 
        <span style={{ color: "#e76767" }}>*</span>
        </label>
        <input
              type="text"
              name="Label"
              className="form-control"
              autocomplete="off"
              value={this.getprobabilityDescriptionValue(i)}
              onChange={(e) => this.handleprobabilityDescription(e, i)}
              style={{marginRight:value?'40px':null}}            />
        </div>
      );
    }
    return matrixfields;
  };
  getImpactMatrix = () => {
    console.log(
      "this.state.probabiltyArray",
      this.state.probabiltyArray
    );
    let matrixfields = [];
    for (let i = 0; i < this.state.heatmapMatrix_value?.value; i++) {
      matrixfields.push(
        <div className="rm-field-container">
          <div className="rowfield">
            <div style={{ paddingBlock: "5px", marginLeft: "28px" }}>
              {" "}
              Full Description {i + 1}{" "}
              <span style={{ color: "#e76767" }}>*</span>
            </div>
            <input
              type="text"
              name="Label"
              className="form-control"
              autocomplete="off"
              value={this.getFullDescriptionValue(i)}
              onChange={(e) => this.handleFullDescription(e, i)}
              style={{ marginLeft: "10px", textTransform: "capitalize" }}
            />
         {/* {this.FullDescriptionValidation(i)} */}
              
           
            <div style={{ paddingLeft: "30px", }}>
              Abbreviation <span style={{ color: "red" }}>*</span>
            </div>
            <input
              type="text"
              name="Label"
              className="form-control"
              style={{ marginLeft: "10px", textTransform: "uppercase" }}
              maxlength="3"
              autocomplete="off"
              value={this.getAbbreviationValue(i)}
              onChange={(e) => this.handleAbbreviation(e, i)}
            />
          </div>
        </div>
      );
    }

    return matrixfields;
  };
  FullDescriptionValidation=()=>{
    let errortoaster = false;
    let obj1 = this.state.probabiltyArray;
    console.log("this.state.heatmapMatrix_value.value",this.state.heatmapMatrix_value.value)

    for (let i = 0; i < this.state.heatmapMatrix_value.value; i++){
    console.log("obj1[i].fullDescription.length",obj1[i].fullDescription.length)

      if(obj1[i].fullDescription.length===0)
 {    console.log("obj1",obj1[i])

         errortoaster = true;
         return errortoaster;
      
    }
    }
    
  
  } 
  handleSelect = (e) => {
    if (e.selected == 1) {
    }
    this.setState({
      selected: e.selected,
    });
  };
  render() {
    const {
      TenantName,
      TenantKey,
      TenantMobile,
      TenantTelephone,
      TenantEmail,
      TenantUserLimit,
      TenantDesc,
      AddressLine1,
      TenantCountry,
      TenantCity,
      TenantPostalCode,
      TenantLogo,
      loader,
      ActivationDate,
      TenantRenewalDate,
      TenantValidDate,
      PrimeSubscription,
      TenantMatrix,
      IsTasksModuleEnabled
    } = this.props;

    const { errors } = this.state;
    return (
      <div className="rm-tanent-cont">
        <div className="rm-form-cont relPosition">
          <h6>
            {this.props.location.tenantRowData ? "Edit Tenant" : "Add Tenant"}
          </h6>

          {loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}

          <form name="form" onSubmit={this.handleSubmit} 
          >
              <TabStrip selected={this.state.selected} onSelect={this.handleSelect}>
              <TabStripTab title="Tenant Details">
            <div className="row"  style={{padding:'20px 10px',fontSize:'14px'}}>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9">
                <div className="rm-form">
                  <div className="rm-field-container">
                    <label>Tenant Name *</label>
                    <input
                      type="text"
                      name="tenantName"
                      className={
                        "form-control" +
                        (this.submitted && !TenantName
                          ? " is-invalid"
                          : errors.TenantName)
                      }
                      placeholder="Enter Tenant Name"
                      onChange={this.handleTenantName}
                      onKeyPress={this.handleTenantName}
                      value={TenantName}
                      autoComplete="off"
                      required
                    />
                    {this.state.submitted && !TenantName && (
                      <div className="invalid-feedback">
                        Tenant Name is required
                      </div>
                    )}
                  </div>
                  <div className="rm-field-container">
                    <label>Tenant Key *</label>
                    <input
                      type="text"
                      name="tenantKey"
                      className={
                        "form-control" +
                        (this.submitted && !TenantKey
                          ? " is-invalid"
                          : errors.TenantKey)
                      }
                      placeholder="Enter Tenant Key"
                      onChange={this.handleTenantKey}
                      onKeyPress={this.handleTenantKey}
                      autoComplete="off"
                      value={TenantKey}
                      required
                      readOnly={this.props.location.tenantRowData}
                    />
                    {this.state.submitted && !TenantKey && (
                      <div className="invalid-feedback">
                        Tenant Key is required
                      </div>
                    )}
                  </div>
                  <div className="rm-field-container">
                    <label>Mobile No.</label>
                    <input
                      type="text"
                      name="mobileNo"
                      className={
                        "form-control" +
                        (this.submitted && !TenantMobile
                          ? " is-invalid"
                          : errors.TenantMobile)
                      }
                      placeholder="Enter Mobile No"
                      autoComplete="off"
                      value={TenantMobile}
                      onChange={this.handleTenantMobile}
                      onKeyPress={this.handleTenantMobile}
                    />
                    {this.state.submitted && !TenantMobile && (
                      <div className="invalid-feedback">
                        Mobile No is required
                      </div>
                    )}
                  </div>
                  <div className="rm-field-container">
                    <label>Telephone No.</label>
                    <input
                      type="tel"
                      name="telePhoneNo"
                      className={
                        "form-control" +
                        (this.submitted && !TenantTelephone
                          ? " is-invalid"
                          : errors.TenantTelephone)
                      }
                      placeholder="Enter TelePhone No"
                      value={TenantTelephone}
                      onChange={this.handleTenantTelephone}
                      autoComplete="off"
                      onKeyPress={this.handleTenantTelephone}
                    />
                    {this.state.submitted && !TenantTelephone && (
                      <div className="invalid-feedback">
                        TelePhone No is required
                      </div>
                    )}
                  </div>
                  <div className="rm-field-container">
                    <label>Email *</label>
                    <input
                      type="email"
                      autoComplete="off"
                      name="email"
                      className={
                        "form-control" +
                        (this.submitted && !TenantEmail
                          ? " is-invalid"
                          : errors.TenantEmail)
                      }
                      placeholder="Enter Email Address"
                      value={TenantEmail}
                      onChange={this.handleTenantEmail}
                      onKeyPress={this.handleTenantEmail}
                      readOnly={this.props.location.tenantRowData}
                    />

                    {this.state.submitted && !TenantEmail && (
                      <div className="invalid-feedback">
                        Email Address is required
                      </div>
                    )}
                  </div>

                  <div className="rm-field-container">
                    <label>Number Of Users</label>
                    <input
                      type="number"
                      autoComplete="off"
                      name="userlimit"
                      className={
                        "form-control" +
                        (this.submitted && !TenantUserLimit
                          ? " is-invalid"
                          : errors.TenantUserLimit)
                      }
                      placeholder="Enter User Limits"
                      value={TenantUserLimit}
                      onChange={this.handleTenantUserLimits}
                      onKeyPress={this.handleTenantUserLimits}
                    />
                    {this.state.submitted && !TenantUserLimit && (
                      <div className="invalid-feedback">
                        User limits is required
                      </div>
                    )}
                  </div>

                  <div className="rm-field-container">
                    <label>Description</label>
                    <input
                      type="text"
                      name="description"
                      autoComplete="off"
                      className={
                        "form-control" +
                        (this.submitted && !TenantDesc
                          ? " is-invalid"
                          : errors.TenantDesc)
                      }
                      placeholder="Enter Description"
                      value={TenantDesc}
                      onChange={this.handleTenantDesc}
                      onKeyPress={this.handleTenantDesc}
                    />
                    {this.state.submitted && !TenantDesc && (
                      <div className="invalid-feedback">
                        Description is required
                      </div>
                    )}
                  </div>

                  <div className="rm-field-container rm-service-plan servicePlan">
                    <label>Service Plan</label>
                    <Select
                      value={this.state.ServicePlan}
                      onChange={(e) =>
                        this.handleDropDownChange(e, "ServicePlan")
                      }
                      options={this.state.servicePlanTypes}
                      placeholder="--Select Service Plan--"
                    />
                  </div>

                  <div className="rm-field-container">
                    <label>Address</label>
                    <input
                      type="text"
                      name="addressLine1"
                      className={
                        "form-control" +
                        (this.submitted && !AddressLine1
                          ? " is-invalid"
                          : errors.AddressLine1)
                      }
                      placeholder="Enter Address Line 1"
                      value={AddressLine1}
                      autoComplete="off"
                      onChange={this.handleAddressLine1}
                      onKeyPress={this.handleAddressLine1}
                    />
                    {this.state.submitted && !AddressLine1 && (
                      <div className="invalid-feedback">
                        Address Line1 is required
                      </div>
                    )}
                  </div>

                  <div className="rm-field-container">
                    <label>Country</label>
                    <input
                      type="text"
                      name="country"
                      className={
                        "form-control" +
                        (this.submitted && !TenantCountry
                          ? " is-invalid"
                          : errors.TenantCountry)
                      }
                      placeholder="Enter Country"
                      onChange={this.handleTenantCountry}
                      onKeyPress={this.handleTenantCountry}
                      autoComplete="off"
                      value={TenantCountry}
                    />
                    {this.state.submitted && !TenantCountry && (
                      <div className="invalid-feedback">
                        Country is required
                      </div>
                    )}
                  </div>

                  <div className="rm-field-container">
                    <label>City</label>
                    <input
                      type="text"
                      name="city"
                      className={
                        "form-control" +
                        (this.submitted && !TenantCity
                          ? " is-invalid"
                          : errors.TenantCity)
                      }
                      placeholder="Enter City"
                      autoComplete="off"
                      onChange={this.handleTenantCity}
                      onKeyPress={this.handleTenantCity}
                      value={TenantCity}
                    />
                    {this.state.submitted && !TenantCity && (
                      <div className="invalid-feedback">City is required</div>
                    )}
                  </div>
                  <div className="rm-field-container">
                    <label>Post Code</label>
                    <input
                      type="text"
                      name="postalCode"
                      className={
                        "form-control" +
                        (this.submitted && !TenantPostalCode
                          ? " is-invalid"
                          : errors.TenantPostalCode)
                      }
                      placeholder="Enter Postal Code"
                      autoComplete="off"
                      onChange={this.handleTenantPostalCode}
                      onKeyPress={this.handleTenantPostalCode}
                      value={TenantPostalCode}
                    />
                    {this.state.submitted && !TenantPostalCode && (
                      <div className="invalid-feedback">
                        Post Code is required
                      </div>
                    )}
                  </div>
                  <div className="date-fieldcontainer">
                    <label>Activation Date</label>
                    <input
                      type="date"
                      name="tenantActivationDate"
                      className={
                        "form-control" +
                        (this.submitted && !ActivationDate
                          ? " is-invalid"
                          : errors.ActivationDate)
                      }
                      onChange={this.handleActivationDate}
                      onKeyPress={this.handleActivationDate}
                      autoComplete="off"
                      value={ActivationDate}
                      readOnly={this.props.location.tenantRowData}
                    ></input>
                    {this.state.submitted && !ActivationDate && (
                      <div className="invalid-feedback">
                        activation Date is required
                      </div>
                    )}
                  </div>
                  <div className="date-fieldcontainer">
                    <label>Renewal Date</label>
                    <input
                      type="date"
                      name="renewalDate"
                      className={
                        "form-control" +
                        (this.submitted && !TenantRenewalDate
                          ? " is-invalid"
                          : errors.TenantRenewalDate)
                      }
                      onChange={this.handleTenantRenewalDate}
                      onKeyPress={this.handleTenantRenewalDate}
                      value={TenantRenewalDate}
                      readOnly={!this.props.location.tenantRowData}
                    />
                    {this.state.submitted && !TenantRenewalDate && (
                      <div className="invalid-feedback">
                        Renewal Date is required
                      </div>
                    )}
                  </div>
                  <div className="date-fieldcontainer">
                    <label>Valid till</label>
                    <input
                      type="date"
                      name="validDate"
                      className={
                        "form-control" +
                        (this.submitted && !TenantValidDate
                          ? " is-invalid"
                          : errors.TenantValidDate)
                      }
                      autoComplete="off"
                      onChange={this.handleTenantValidDate}
                      onKeyPress={this.handleTenantValidDate}
                      value={TenantValidDate}
                      readOnly
                    ></input>
                    {this.state.submitted && !TenantValidDate && (
                      <div className="invalid-feedback">
                        valid till date is required
                      </div>
                    )}
                  </div>
                  <div className="matrixfield">
                    <label>Heatmap Matrix</label>
                    <DropDownList
                      style={{ width: "260px" }}
                      onChange={this.handletenantMatrix}
                      className={
                        "form-control" +
                        (this.submitted && !TenantMatrix
                          ? " is-invalid"
                          : errors.TenantMatrix)
                      }
                      value={this.state.heatmapMatrix_value}
                      data={this.state.heatmapMatrixlist}
                      valueField="value"
                      textField="text"
                    />
                    {this.state.submitted && !TenantMatrix && (
                      <div className="invalid-feedback">
                        Heatmap Matrix is required
                      </div>
                    )}
                  </div>
                  <div
                    className="rm-field-container"
                    style={{
                      justifyContent: "center",
                      paddingTop: "30px",
                      paddingLeft: "30px",
                    }}
                  >
                    <Checkbox
                      className={
                        "form-control" +
                        (this.submitted && !PrimeSubscription
                          ? " is-invalid"
                          : errors.PrimeSubscription)
                      }
                      value={PrimeSubscription}
                      label={"Prime Subscription Included"}
                      onChange={this.handleprimeSubscription}
                    />
                    {/* <label>Prime Subscription Included</label> */}
                    {this.state.submitted && !PrimeSubscription && (
                      <div className="invalid-feedback">
                        Prime Subscription is required
                      </div>
                    )}
                  </div>
                  <div
                    className="rm-field-container"
                    style={{
                      justifyContent: "center",
                      paddingTop: "30px",
                      paddingLeft: "30px",
                    }}
                  >
                    <Checkbox
                      className={
                        "form-control" +
                        (this.submitted && !IsTasksModuleEnabled
                          ? " is-invalid"
                          : errors.IsTasksModuleEnabled)
                      }
                      value={IsTasksModuleEnabled}
                      label={"Task Module Subscription Included"}
                      onChange={this.handleTasksModuleEnabled}
                    />
                    {/* <label>Prime Subscription Included</label> */}
                    {this.state.submitted && !IsTasksModuleEnabled && (
                      <div className="invalid-feedback">
                        Task Module Subscription is required
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                <div className="rm-form-logo">
                  <div className="rm-field-container">
                    <label>Upload Tenant Logo</label>
                    <div className="d-flex align-items-center justify-content-center borderedBox">
                      <div className="d-flex align-items-center tenantLogoupload justify-content-center">
                        {TenantLogo != "" ? (
                          <div className="uploadedImage">
                            <img src={TenantLogo}></img>
                          </div>
                        ) : null}

                        <div>
                          <div className="uploadImage">
                            <input
                              type="file"
                              name="logo"
                              className={
                                "form-control" +
                                (this.submitted && !TenantLogo
                                  ? " is-invalid"
                                  : errors.TenantLogo)
                              }
                              placeholder="Tenant Logo"
                              onChange={this.handleTenantLogo}
                            />
                            <label>Browse</label>
                          </div>
                          <p>File should be .png or .jpg format</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </TabStripTab>
            <TabStripTab title="Impact Definition">
                <div className="impact-tab">
              <smal
                    style={{
                      marginLeft: "25px",
                      marginTop: "13px",
                    }}
                  >
                    <p>
                      Note: Range names must be entered in increasing order of
                      severity i.e. Lowest to Highest. For example, if the
                      selection is 3 x 3 and the range names are Low, Medium and
                      High, Full Description 1 must be Low, Full Description 2
                      must be Medium and Full Description 3 must be High.
                    </p>
                  </smal>
                  <label
                    style={{
                      marginLeft: "20px",
                      marginBottom: "-16px",
                      // marginTop: "13px",
                      fontSize: "17px",
                      fontWeight: "bold",
                    }}
                  >
                   Impact Definition
                  </label>
                  <div className="dynamix_fields">
                    <br></br>
                    {this.getImpactMatrix()}
                  </div>
                  </div>
              </TabStripTab>
              <TabStripTab title="Range Definition">
                <div className="probability-tab">
              <label
                    style={{
                      // marginLeft: "25px",
                      marginBottom: "-16px",
                      marginTop: "13px",
                      fontSize: "17px",
                      fontWeight: "bold",
                    }}
                  >
                    Range Definition
                  </label>
                  <div className="imp_dynamix_fields">
                    <br></br>
                    {this.getProbabilityMatrix()}
                    
                  </div>
                  </div>
              </TabStripTab>
              </TabStrip>
            <div className="btn-group"  style={{marginLeft:'16px'}}>
              <button className="rm-btn-primary">
                {this.props.location.tenantRowData ? "Update" : "Submit"}
              </button>
              &nbsp;&nbsp;
              <button
                className="rm-btn-primary"
                onClick={(e) => {
                  this.cancelTenantCreationData(e);
                }}
              >
                CANCEL
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => {
  console.log("state",state);
  return {
    TenantName: state.TenantCreation.tenantName,
    TenantKey: state.TenantCreation.tenantKey,
    TenantMobile: state.TenantCreation.tenantMobile,
    TenantTelephone: state.TenantCreation.tenantTelephone,
    TenantEmail: state.TenantCreation.tenantEmail,
    TenantUserLimit: state.TenantCreation.tenantUserLimit,
    TenantDesc: state.TenantCreation.tenantDes,
    ServicePlan: state.TenantCreation.tenantServicePlan,
    AddressLine1: state.TenantCreation.addressLine1,
    AddressLine2: state.TenantCreation.addressLine2,
    TenantCountry: state.TenantCreation.tenantCountry,
    TenantState: state.TenantCreation.tenantState,
    TenantCity: state.TenantCreation.tenantCity,
    TenantPostalCode: state.TenantCreation.tenantPostalCode,
    TenantLogo: state.TenantCreation.tenantLogo,
    loader: state.TenantCreation.loaderStatus,
    tenantcreationfailure: state.TenantCreation.tenantCreationFailure,
    ActivationDate: state.TenantCreation.activationDate,
    TenantRenewalDate: state.TenantCreation.tenantRenewalDate,
    TenantValidDate: state.TenantCreation.tenantValidDate,
    PrimeSubscription: state.TenantCreation.primeSubscription,
    TenantMatrix: state.TenantCreation.tenantMatrix,
    IsTasksModuleEnabled:state.TenantCreation.isTasksModuleEnabled
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuperAdminTenantCretion);
